import RIORadioButton from '@rio-cloud/rio-uikit/RadioButton';
import type { PropsWithChildren } from 'react';

import type { PropsWithId } from '../types';

interface RadioButtonProps {
    name: string;
    disabled?: boolean;
    custom?: boolean;
    checked?: boolean;
    onChange?: () => void;
    className?: string;
}

const RadioButton = ({
    name,
    disabled,
    custom,
    checked,
    onChange,
    className,
    id,
    children,
}: PropsWithId<PropsWithChildren<RadioButtonProps>>) => (
    <RIORadioButton
        name={name}
        disabled={disabled}
        custom={custom}
        onChange={onChange}
        className={className}
        checked={checked}
        {...(id ? { 'data-testid': id } : {})}
    >
        {children}
    </RIORadioButton>
);

export default RadioButton;
